import React from "react"

import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

import "./hero.css"

const QuandaryBanner = () => {
  // const { heroImage } = useStaticQuery(
  //   graphql`
  //     {
  //       heroImage: file(relativePath: { eq: "new-images/twig.jpeg" }) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 1600
  //             layout: CONSTRAINED
  //             placeholder: DOMINANT_COLOR
  //             formats: [AUTO, WEBP, AVIF]
  //           )
  //         }
  //       }
  //     }
  //   `
  // )

  // const heroImageData = getImage(heroImage)

  // Use like this:
  // const bgImage = convertToBgImage(heroImageData)

  // console.log("bgImage", bgImage)

  return (
    <>
      <div
        className="hero-banner hero-whitefade-tech-banner"
        style={{
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 mr-auto">
              <div className="hero-procurement">
                {/* <p className="h5 text-light-blue text-uppercase font-weight-bold mt-5 mt-md-0 mb-4">
                  QUANDARY TECHNOLOGY CONSULTING
                </p> */}
                <h1 className="page-title text-light-blue mt-0">
                  Systems Designed to Support Business Growth
                </h1>
                <h3 className="mt-2 mb-4">
                  Keep your business agile and get more out of your tech stack.
                  A Lot More.
                </h3>
                <p>
                  <Link
                    aria-label="link"
                    className="font-weight-medium"
                    to="/contact/"
                  >
                    Speak to a Consultant
                    <i className="ml-2 item-arrow" aria-hidden="true"></i>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default QuandaryBanner
